import { useState } from "react";
import { CheckCircle, EnvelopeSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const TYPES = [
  { key: "general", label: "General" },
  { key: "luxury", label: "Luxury Request" },
  { key: "wrap", label: "Neon Wrap" },
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", type: "general", subject: "", message: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/inquiries", form);
      setDone(true);
      toast.success("Message sent");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-16" data-testid="contact-page">
      <div className="flex items-center gap-3 mb-2">
        <EnvelopeSimple weight="duotone" size={26} className="text-primary" />
        <p className="overline text-primary">Contact & Inquiries</p>
      </div>
      <h1 className="text-4xl sm:text-5xl tracking-tighter font-light mb-3">Let's talk.</h1>
      <p className="text-muted-foreground mb-10">Wrap projects, luxury requests or general brand communication — reach the team here.</p>

      {done ? (
        <div className="p-10 rounded-2xl bg-card border border-primary/30 text-center" data-testid="contact-success">
          <CheckCircle weight="fill" size={56} className="text-primary mx-auto mb-5" />
          <h3 className="text-2xl font-modern font-medium mb-2">Message sent</h3>
          <p className="text-muted-foreground">We'll get back to you shortly.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <div className="flex flex-wrap gap-2 mb-2">
            {TYPES.map((t) => (
              <button type="button" key={t.key} onClick={() => setForm({ ...form, type: t.key })}
                className={`overline px-4 py-2 rounded-full border transition-colors ${form.type === t.key ? "bg-primary text-primary-foreground border-primary" : "border-white/15 text-muted-foreground hover:text-white"}`}
                data-testid={`contact-type-${t.key}`}>
                {t.label}
              </button>
            ))}
          </div>
          <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full bg-transparent border border-white/20 rounded-lg px-4 py-3 outline-none focus:border-primary transition-colors" data-testid="contact-name" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-transparent border border-white/20 rounded-lg px-4 py-3 outline-none focus:border-primary transition-colors" data-testid="contact-email" />
          <input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
            className="w-full bg-transparent border border-white/20 rounded-lg px-4 py-3 outline-none focus:border-primary transition-colors" data-testid="contact-subject" />
          <textarea required rows={5} placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full bg-transparent border border-white/20 rounded-lg px-4 py-3 outline-none focus:border-primary transition-colors resize-none" data-testid="contact-message" />
          <button disabled={loading} className="w-full bg-primary text-primary-foreground py-3.5 rounded-full font-modern font-medium hover:bg-primary/90 transition-colors disabled:opacity-60" data-testid="contact-submit">
            {loading ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </div>
  );
}
